import { Directive, ViewContainerRef } from '@angular/core';

@Directive({
  selector: '[appSidebarHost]',
})
export class SidebarHostDirective {
  constructor(public viewContainerRef: ViewContainerRef) {}
}
